import { Injectable } from '@angular/core';
import { DataService } from '../../../../Autofacets-Core/src/app/services/data.service';
import { VehicleCustomerMappingModel } from '../business-entities/Customer-detail.model';
import { GenericResponse } from '../business-entities/generic-response';
import { VehicleListViewModel, VehicleModel } from '../business-entities/vehicle-list-view-model';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class VehicleDataService {
    constructor(private dataProvider: DataService) {
    }
    async getVehicleList(vehicleRequestModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetVehicleServiceList, vehicleRequestModel).toPromise();
    }

    getVehicleById(id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetVehicleById, id).toPromise();
    }
    editVehicle(model: VehicleListViewModel): Promise<any> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.EditVehicle, model).toPromise();
    }

    getVehicleByLicencePlateNo(licensePlate: string): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetVehicleByLicensePlateNo, licensePlate).toPromise();
    }

    async GetVehicleOwnerTypeDropdownList(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetVehicleOwnerTypeDropdownList).toPromise();
    }

    async GetVehicleTransmissionDropdownList(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetVehicleTransmissionDropdownList).toPromise();
    }
    async AddEditVehicle(vehicleInfo: VehicleModel): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditVehicle, vehicleInfo).toPromise();
    }
    async crmAddEditVehicle(vehicleInfo: any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.CrmAddEditVehicle, vehicleInfo).toPromise();
    }

    async getVehicleByCustomerId(customerId: number, customerGuid: string, isToFetchLocalOnly: boolean): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetVehicleByCustomerId, customerId, customerGuid, isToFetchLocalOnly).toPromise();
    }

    async UnmapCustomerVehicle(vehicleRequestModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UnmapCustomerVehicle, vehicleRequestModel).toPromise();
    }

    getCustomerDetailByVehicleId(id: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetCustomerDetailByVehicleId, id).toPromise();
    }

    updateVehicleCustomerMapping(vehicleCustomerMapping: VehicleCustomerMappingModel): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateVehicleCustomerMapping, vehicleCustomerMapping).toPromise();
    }

    async ResyncVehicle(licensePlate: string, moduleId: number): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.ResyncVehicle, licensePlate, moduleId).toPromise();
    }

    async getVehicleFrmoDataFactoryByLicencePlateNo(licensePlate: string): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.VehicleInformation, licensePlate).toPromise();
    }

    GetVehicleOwnershipHistory(vehicleOwnershipRequestModel: any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetVehicleOwnershipHistory, vehicleOwnershipRequestModel).toPromise();
    }
    async HardDeleteVehicle(model: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.HardDeleteVehicle, model).toPromise(); 
    }
    async DeleteVehicle(model: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteVehicle, model).toPromise(); 
    }
    async SearchCustomerThroughDF(model: any): Promise<GenericResponse<any>>{
        return this.dataProvider.Post<GenericResponse<any>>(Urls.SearchCustomerThroughDF,model).toPromise();
    }
}